import LogRocket from 'logrocket';
import template from './twoFactorAuth.html';


export default {
  name: 'twoFactorAuthComponent',
  template,
  controller: TwoFactorAuthController,
  controllerAs: 'TwoFactAuthCtrl',
  bindings: {
    user: '<',
    authenticator: '<',
    getProfile: '&'
  }
};

/* @ngInject */
function TwoFactorAuthController(ProfileService, UsersService, growl) {
  const vm = this;

  vm.getNewCode = getNewCode;
  vm.setSecondFactor = setSecondFactor;
  vm.disableTwoFactor = disableTwoFactor;

  function getNewCode() {
    if (vm.user) {
      let growlMessage = growl.info('Refreshing Two factor authentication...', {
        disableCloseButton: true
      });
      UsersService.clearUsersTwoFactorSettings(vm.user.id)
        .then(() => {
          growlMessage.destroy();
          growlMessage = growl.success('Two factor authentication refreshed.');
          vm.user.secondFactorEnabled = false;
          vm.getProfile();
        })
        .catch((res) => {
          growlMessage.destroy();
          const error = 'Error clearing two factor authentication';
          growlMessage = growl.error(res.error, { title: error });
          LogRocket.track(error);
        });
    }
  }

  function setSecondFactor() {
    delete vm.authenticator.error;
    ProfileService.setSecondFactor({
      userId: vm.user.id,
      key: vm.authenticator.enteredKey
    })
      .then(() => {
        vm.user.secondFactorEnabled = true;
      })
      .catch((res) => {
        vm.authenticator.error = res.error;
      });
  }

  function disableTwoFactor() {
    let growlMessage;

    UsersService.clearUsersTwoFactorSettings(vm.user.id)
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('Two Factor Disabled');
        vm.user.secondFactorEnabled = false;
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error);
        LogRocket.track('Two Factor Disable Error');
        vm.authenticator.error = res.error;
      });
  }
}
